export const FINALANALYSIS_CONSTS = {
  CM_ID_INDEX: 'id',
  OPTIMIZEDQTY: 'Suggested Qty'
};
